import * as React from 'react';

import Field, { FieldProps } from './Field.tsx';
import { useControllableState } from '../../utils/useControllableState.tsx';

export interface StringFieldProps
    extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'defaultValue' | 'prefix'>,
        FieldProps {
    prefix?: React.ReactNode;
}

const StringField = ({
    ref,
    defaultValue,
    value: propsValue,
    onValueChange,
    onChange,
    onBlur,
    onCommit,
    controls,
    className,
    readOnly,
    disabled,
    inputRef = undefined,
    maxLength,
    prefix,
    ...props
}: StringFieldProps) => {
    const [value, setValue] = useControllableState(defaultValue, propsValue, onValueChange);

    const handleChange = (e: any) => {
        setValue(e.target.value);
        onChange?.(e);
    };

    const handleBlur = (e: any) => {
        onBlur?.(e);
        onCommit?.(value);
    };

    return (
        <Field className={className} readOnly={readOnly} disabled={disabled} ref={ref}>
            <Field.Input className="relative">
                {prefix && (
                    <span className="flex flex-none items-center pl-2 text-content-weak" aria-hidden>
                        {prefix}
                    </span>
                )}
                <input
                    type="text"
                    value={value || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="px-2 py-1.5 flex-1 min-w-0 bg-surface-transparent outline-none"
                    readOnly={readOnly}
                    disabled={disabled}
                    maxLength={maxLength}
                    {...props}
                    ref={inputRef}
                />
                {maxLength && (
                    <div className="text-xs text-content-medium absolute right-0.5 top-1/2 -translate-y-1/2 bg-surface-weak px-1 py-0.5 rounded pointer-events-none">
                        {(value || '').length}/{maxLength}
                    </div>
                )}
            </Field.Input>
            <Field.Controls>{controls}</Field.Controls>
        </Field>
    );
};

export default StringField;
